// 高医个单批改模块接口
import instance from './request';
import qs from 'qs';
let api = {};

// 个单批改保单数据查询接口
api.getBatchInfo = function(policyId) {
  return instance.post(`/mgu/batch/getBatchInfo/${policyId}`);
};
// 个单批改保费计算接口
api.calBatchPremium = function(data) {
  return instance.post(`/mgu/batch/calBatchPremium`, data);
};
// 个单批改提交接口
api.submitBatchData = function(data) {
  return instance.post(`/mgu/batch/submitBatchData`, data);
};
// 个单批改上传附件接口
api.batchUploadFile = function(data) {
  return instance.post(`/mgu/batch/uploadFile`, data);
};
// 下载保单接口
api.exportPolicy = (data) => {
  return instance.post(`/authorization/policyOperation/exportPolicy?${qs.stringify(data)}`);
};
export default api;
